"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";

import { createDefaultDataBindings } from "../Category/getCategoryContentBindings";

import { CATEGORY_NAME_INPUTS } from "./CategoryName.inputs.builder";

export const CategoryNameComponent: RegisteredComponent = {
  name: "Category name",
  component: dynamic(async () => (await import("./CategoryName")).CategoryName),
  models: [getBuilderModelName("category")],
  defaults: {
    bindings: createDefaultDataBindings<typeof CATEGORY_NAME_INPUTS>({
      name: "categoryName",
    }),
  },
  inputs: CATEGORY_NAME_INPUTS,
};
